import React, {lazy} from 'react';
import {HashRouter as Router, Navigate, Route, Routes} from 'react-router-dom';
import Layout from './ui/_commons/layouts/Layout';

import WebProConnectedLayout from './ui/_commons/layouts/WebProConnectedLayout';
import Menu from './ui/menu/Menu';
import ContractSelection from './ui/webProContracts/screens/ContractSelection';
import AuthLayout from './ui/authentication/layout/AuthLayout';

import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SelfAdminRouter from './ui/self-admin/SelfAdminRouter';
import {useTranslation} from 'react-i18next';
import RequireAuth from './components/RequireAuth';
import CodeSplit from './components/CodeSplit';
import OrderRouter from './ui/order/OrderRouter';

const GclRouter = lazy(() => import('./ui/gcl/GclRouter'));
const AuthenticationRouter = lazy(() => import('./ui/authentication/AuthenticationRouter'));
const DashboardRouter = lazy(() => import('./ui/dashboard/DashboardRouter'));
const SynthesisRouter = lazy(() => import('./ui/synthesis/SynthesisRouter'));
const IhubRouter = lazy(() => import('./ui/ihub/IhubRouter'));
const EDocumentsRouter = lazy(() => import('./ui/e-docs/EDocumentsRouter'));
const MessagingRouter = lazy(() => import('./ui/secure-messaging/MessagingRouter'));
const PaymentRouter = lazy(() => import('./ui/payment/PaymentRouter'));
const SettingsRouter = lazy(() => import('./ui/settings/SettingsRouter'));
const ProductRouter = lazy(() => import('./ui/product/ProductRouter'));
const OrderTrackingRouter = lazy(() => import('./ui/order-tracking/OrderTrackingRouter'));

const AppRouter = () => {
  return (
    <>
      <ToastContainer
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
                style={{'padding': '12px'}}
      />
      <Router>
        <AllRoutes/>
      </Router>
    </>
  );
};

const AllRoutes = () => {

  const {t} = useTranslation(['authentication']);

  return (
    <Routes>
      <Route index element={<Navigate to={'/contract-selection'}/>}/>

      <Route path={'/*'} element={<Layout/>}>
        <Route path={'auth/*'}
               element={
                 <CodeSplit>
                   <AuthenticationRouter/>
                 </CodeSplit>}
        />

        <Route path={'gcl/*'}
               element={
                 <RequireAuth>
                   <CodeSplit>
                     <GclRouter/>
                   </CodeSplit>
                 </RequireAuth>
               }
        />

        {/* HIDE ORDER PAGES */}

        {/*<Route path={'order/*'}*/}
        {/*       element={*/}
        {/*           <CodeSplit>*/}
        {/*               <OrderRouter/>*/}
        {/*           </CodeSplit>*/}
        {/*       }*/}
        {/*/>*/}

        <Route path={'/*'} element={
            <RequireAuth>
                <CodeSplit>
                    <AuthLayout title={t('authentication:title')}/>
                </CodeSplit>
            </RequireAuth>
        }>
            <Route path={'contract-selection'}
                   element={<ContractSelection/>}/>
        </Route>

      </Route>

      <Route path={'/*'} element={<Layout/>}>

        <Route path={'/*'} element={<RequireAuth><WebProConnectedLayout menuComponent={<Menu/>}/></RequireAuth>}>

          <Route path={'redirect/dashboard'}>
            <Route index element={<CodeSplit inner><DashboardRouter/></CodeSplit>}/>
            <Route path={'*'} element={<CodeSplit inner><DashboardRouter/></CodeSplit>}/>
          </Route>

          <Route path={':ctrPro/:primaryCtr/dashboard'}>
            <Route path={'./'} element={<CodeSplit inner><DashboardRouter/></CodeSplit>}/>
            <Route path={'*'} element={<CodeSplit inner><DashboardRouter/></CodeSplit>}/>
          </Route>

          <Route path={':ctrPro/:primaryCtr/synthesis'}>
            <Route path={'./'} element={<CodeSplit inner><SynthesisRouter/></CodeSplit>}/>
            <Route path={'*'} element={<CodeSplit inner><SynthesisRouter/></CodeSplit>}/>
          </Route>

          <Route path={':ctrPro/:primaryCtr/ihub/*'}
                 element={<CodeSplit inner><IhubRouter/></CodeSplit>}/>
          {import.meta.env.VITE_ENABLE_EDOCUMENTS === 'true' &&
              <Route path={':ctrPro/:primaryCtr/e-documents/*'}
                     element={<CodeSplit inner><EDocumentsRouter/></CodeSplit>}/>
          }
          {import.meta.env.VITE_ENABLE_SECURE_MESSAGING === 'true' &&
              <Route path={':ctrPro/:primaryCtr/secure-messaging/*'}
                     element={<CodeSplit inner><MessagingRouter/></CodeSplit>}/>
          }

          {import.meta.env.VITE_ENABLE_SELF_ADMIN === 'true' &&
              <Route path={':ctrPro/:primaryCtr/self-admin'}>
                  <Route path={'./'} element={<CodeSplit inner><SelfAdminRouter/></CodeSplit>}/>
                  <Route path={'*'} element={<CodeSplit inner><SelfAdminRouter/></CodeSplit>}/>
              </Route>
          }

          {import.meta.env.VITE_ENABLE_PAYMENT === 'true' &&
              <Route path={':ctrPro/:primaryCtr/payment'}>
                  <Route path={'./'} element={<CodeSplit inner><PaymentRouter/></CodeSplit>}/>
                  <Route path={'*'} element={<CodeSplit inner><PaymentRouter/></CodeSplit>}/>
              </Route>
          }
          {/* HIDE THE PRODUCT AND ORDER TRACKING PAGES */}

          {/*{import.meta.env.VITE_ENABLE_PRODUCT === 'true' &&*/}
          {/*    <Route path={':ctrPro/:primaryCtr/product'}>*/}
          {/*         <Route path={'./'} element={<CodeSplit inner><ProductRouter/></CodeSplit>}/>*/}
          {/*         <Route path={'*'} element={<CodeSplit inner><ProductRouter/></CodeSplit>}/>*/}
          {/*    </Route>*/}
          {/*}*/}

          {/*{import.meta.env.VITE_ENABLE_ORDER_TRACKING === 'true' &&*/}
          {/*    <Route path={':ctrPro/:primaryCtr/order-tracking'}>*/}
          {/*        <Route path={'./'} element={<CodeSplit inner><OrderTrackingRouter/></CodeSplit>}/>*/}
          {/*        <Route path={'*'} element={<CodeSplit inner><OrderTrackingRouter/></CodeSplit>}/>*/}
          {/*    </Route>*/}
          {/*}*/}

          {import.meta.env.VITE_ENABLE_SETTINGS === 'true' &&
              <Route path={':ctrPro/:primaryCtr/settings'}>
                  <Route path={'./'} element={<CodeSplit inner><SettingsRouter/></CodeSplit>}></Route>
                  <Route path={'*'} element={<CodeSplit inner><SettingsRouter/></CodeSplit>}></Route>
              </Route>
          }
        </Route>
      </Route>
    </Routes>
  );
};


export default AppRouter;
